<template>
    <div class="nodatamain">
        <img src="@/assets/common/imgs/PCimg/nodata.png" alt="" :class="{full:full}">
        <p class="msg">{{innerText}}</p>
    </div>
</template>
<script>
export default {
    props:{
        innerText:{
            default:"此页面还没有添加内容哦~",
        },
        full:false,
    },
    data(){
        return{
            mainWidth:0,
        }
    },
    beforeMount(){
        
    }
}
</script>
<style lang="scss" scoped>
    .nodatamain{
        text-align: center;
        padding: 30px 0;
        .full{
            width: 100%;
        }
        .msg{
            font-size: 14px;
            color: #777;
            margin-top: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/nodata.vue